import { render, staticRenderFns } from "./tejidosBlandos.vue?vue&type=template&id=3a340888&"
import script from "./tejidosBlandos.vue?vue&type=script&lang=js&"
export * from "./tejidosBlandos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports